// extracted by mini-css-extract-plugin
export var aircallIframe = "_ju-3";
export var fabContainer = "_ju-5";
export var fabRinging = "_ju-6";
export var loadingOverlay = "_ju-4";
export var pulse = "_ju-7";
export var widgetContent = "_ju-2";
export var widgetPanel = "_ju-0";
export var widgetPanelExpanded = "_ju-1";